import { useContext, useLayoutEffect } from 'react';
import { useThree } from 'react-three-fiber';
import { Color } from 'three';

import { ConfigContext } from './config';

/**
 * to get this to match the css color correctly,
 * add disableGamma={true} to <EffectComposer>
 */
const Background = () => {
  const { scene } = useThree();
  const { useConfig } = useContext(ConfigContext);
  const backgroundColor = useConfig('backgroundColor');

  useLayoutEffect(() => {
    scene.background = new Color(backgroundColor);
    scene.background.convertSRGBToLinear();
  }, [scene, backgroundColor]);

  return null;
};

export default Background;
